import { Component, OnInit } from '@angular/core';
import { DeviceBehfa_Interface } from 'src/app/Interface/DeviceBehfa_Interface';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DeviceBehfaService } from 'src/app/Service/DeviceBehfa/DeviceBehfa.service';
import { DeviceGroupService } from 'src/app/Service/DeviceGroup/DeviceGroup.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-DeviceBehfaPerformance',
  templateUrl: './DeviceBehfaPerformance.component.html',
  styleUrls: ['./DeviceBehfaPerformance.component.scss']
})
export class DeviceBehfaPerformanceComponent implements OnInit {

  Token: string = ""
  Filter_Type_Lap: String = '1'
  Filter_Code: String = ''
  ExpertCalibration: String = ''


  page: number = 0;
  Procssing: boolean = false;


  DataList_DeviceBehfa: Array<DeviceBehfa_Interface> = []
  constructor(
    private DeviceBehfa_Service: DeviceBehfaService,
    private Alertify_Service: AlertifyService,
    private Nav_Service: NavService,
    private DeviceGroup_Service: DeviceGroupService,
  ) { }


  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token, 2230).subscribe(
      data => {
        this.Read_First_Device_Group()
      }
      , error => {
        localStorage.clear()
        location.reload();
      }
    )


  }




  ReadData_DeviceBehfa(StartSearchDate, EndSearchDate) {
    this.Procssing = true

    this.DeviceBehfa_Service.GetRecordPerformance(this.Token,
      StartSearchDate,
      EndSearchDate,
      this.Filter_Code,
      Number(this.First_Device_Group_Selected),
      Number(this.Second_Device_Group_Selected),
      Number(this.Filter_Type_Lap)).subscribe(
        data => {
          this.DataList_DeviceBehfa = data
          this.Procssing = false

        }, error => {
          localStorage.clear()
          location.reload();
        }
      )

  }

  exportexcel(): void {
    /* table id is passed over here */
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, "DaroDevice.xlsx");

  }


  //#region Device Group

  DataList_First_Device_Group: Array<General_Interface> = []
  DataList_Second_Device_Group: Array<General_Interface> = []

  First_Device_Group_Selected: string = '0'
  Second_Device_Group_Selected: string = '0'

  Read_First_Device_Group() {
    this.DeviceGroup_Service.GetDeviceGroup(this.Token, 0).subscribe(
      data => {
        this.DataList_First_Device_Group = data
      }
    )
  }

  Read_Second_Device_Group() {
    this.Second_Device_Group_Selected = "0"
    this.DeviceGroup_Service.GetDeviceGroup(this.Token, Number(this.First_Device_Group_Selected)).subscribe(
      data => {
        this.DataList_Second_Device_Group = data
      }
    )
  }

  //#endregion






}
